import React, { useEffect, useState } from "react";
import { USFlag } from "../../../../public/assets";
import AccountBalanceInput from "../../../components/Accounts/AccountBalanceInput";
import Layout from "../../../components/Accounts/Layout";
import { InputItem } from "../data";
import InputContainer from "../../../components/Accounts/InputContainer";
import Button from "../../../components/Button/Button";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../../graphql/queries/accounts";
import { InputAndTransactionFeeWrapper } from "../FipayTransfer/PaymentDetails";
import {
  recipientCities,
  recipientProfessions,
  recipientStates,
  recipientType,
  wireTransferInputs,
} from "./data";
import WrappedRadioButton from "../../../components/Accounts/WrappedRadioButton";
import CustomSelect from "../../../components/Accounts/SelectComponent";
import { setFormValues } from "../../../store/formValues";

interface PaymentDetailsProps {
  handleNext: (step: number) => void;
  prevValues: InputItem[];
  transferType: string;
}

const RecipientDetailsWireTransfer: React.FC<PaymentDetailsProps> = ({
  handleNext,
  transferType,
}) => {
  const id = useSelector((state: RootState) => state.user?.user?.id);
  const dispatch = useDispatch();

  const [recipientCountry, setRecipientCountry] = useState(
    "United States of America"
  );
  const formValues = useSelector(
    (state: RootState) => state.formValues.wireTransfer
  );
  const [selectedOption, setSelectedOption] = useState<{
    RecipientProfession: string;
    RecipientState: string;
    RecipientCity: string;
    [key: string]: any;
  }>({
    RecipientProfession: "",
    RecipientState: "",
    RecipientCity: "",
  });
  const [formikValues, setFormikValues] = useState({
    RecipientLegalName: formValues?.RecipientLegalName || "",
    RecipientType: formValues?.RecipientType || "",
    RecipientProfession: formValues?.RecipientProfession || "",
    RecipientPhoneNumber: formValues?.RecipientPhoneNumber || "",
    RecipientCountry: recipientCountry,
    RecipientAddress: formValues?.RecipientAddress || "",
    RecipientState: formValues?.RecipientState || "",
    RecipientCity: formValues?.RecipientCity || "",
  });
  const [recipientsType, setRecipientsType] = useState("");

  const [showOptions, setShowOptions] = useState<{
    RecipientProfession: boolean;
    RecipientState: boolean;
    RecipientCity: boolean;
    [key: string]: boolean;
  }>({
    RecipientProfession: false,
    RecipientState: false,
    RecipientCity: false,
  });
  // const { data: userBankQueryData, refetch: refetchUserBank } = useQuery(
  //   getUserBankDetails,
  //   {
  //     variables: { getUserBankDetailsId: id },
  //   }
  // );

  const { data: userBankQueryData, refetch: refetchUserBank } =
    useQuery(getUserBankDetails);

  const handleShowOption = (name: string) => {
    setShowOptions((prevOptions) => ({
      ...prevOptions,
      [name]: !prevOptions[name],
    }));
  };

  const onTypeChange = (option: string, name: string) => {
    setRecipientsType(option);
    setFormikValues((prevValues) => ({ ...prevValues, [name]: option }));
  };
  const financeDetails = userBankQueryData?.getUserBankDetails || "";

  const amountValue = financeDetails?.userFinancialDetails?.available || 0;

  useEffect(() => {
    refetchUserBank();
  }, [id]);

  return (
    <Layout height="40.5rem">
      <AccountBalanceInput
        icon="/assets/icons/usFlag.svg"
        currencyTitle={"USD Balance"}
        amountValue={amountValue}
        currency={"$"}
        label={"Balance to send from"}
      />
      <Formik
        initialValues={formikValues}
        validationSchema={Yup.object({
          RecipientLegalName: Yup.string().required("Required"),
          RecipientType: Yup.string().required("Required"),
          RecipientProfession: Yup.string().required("Required"),
          RecipientPhoneNumber: Yup.string().required("Required"),
          RecipientCountry: Yup.string().required("Required"),
          RecipientAddress: Yup.string().required("Required"),
          RecipientState: Yup.string().required("Required"),
          RecipientCity: Yup.string().required("Required"),
        })}
        onSubmit={(values) => {
          try {
            handleNext(1);
            const formData = {
              ...values,
              TransactionType: "Wire Transfer",
            };
            dispatch(setFormValues({ [transferType]: formData }));
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <>
              {wireTransferInputs.map((input, index) => (
                <InputAndTransactionFeeWrapper key={index}>
                  {input.label === "Recipient's Type" ? (
                    <WrappedRadioButton
                      itemTypes={recipientType}
                      onTypeChange={(option: string) => {
                        onTypeChange(option, input.name);
                        formik.handleChange({
                          target: {
                            name: input.name,
                            value: option,
                          },
                        });
                      }}
                      activeType={""}
                      label={"Recipient's Type"}
                    />
                  ) : input.label === "Recipient's Profession" ||
                    input.label === "Recipient's State" ||
                    input.label === "Recipient's City" ? (
                    <CustomSelect
                      selectedOption={selectedOption[input.name]}
                      showList={showOptions[input.name]}
                      options={
                        input.label === "Recipient's Profession"
                          ? [...recipientProfessions]
                          : input.label === "Recipient's State"
                            ? [...recipientStates]
                            : [...recipientCities]
                      }
                      selectOption={(option: string) => {
                        setSelectedOption((prevOptions) => ({
                          ...prevOptions,
                          [input.name]: option,
                        }));
                        formik.handleChange({
                          target: {
                            name: input.name,
                            value: option,
                          },
                        });
                      }}
                      placeHolder={"Select"}
                      toggleShowList={() => handleShowOption(input.name)}
                      label={input.label}
                    />
                  ) : (
                    <InputContainer
                      name={input.name}
                      label={input.label}
                      type={input.type}
                      placeholder={input.placeholder}
                      value={
                        formik.values[
                          input.name as keyof typeof formik.values
                        ] || ""
                      }
                      onChange={(e) => {
                        formik.handleChange(e);
                        const { name, value } = e.target;
                        setFormikValues((prevValues) => ({
                          ...prevValues,
                          [name]: value,
                        }));
                      }}
                      width={"100%"}
                      error={
                        formik.touched[
                          input.name as keyof typeof formik.touched
                        ] &&
                        formik.errors[input.name as keyof typeof formik.errors]
                      }
                      disabled={input.name === "RecipientCountry"}
                    />
                  )}
                </InputAndTransactionFeeWrapper>
              ))}
            </>

            <Button
              id={""}
              type="submit"
              padding={"10px 45%"}
              title={"Next"}
              border="10px"
              green
              disabled={!formik.isValid || !formik.dirty}
            />
          </form>
        )}
      </Formik>
    </Layout>
  );
};

export default RecipientDetailsWireTransfer;
